function _getCanonicalHost(hostname) {
  if (!hostname.includes('.') || hostname.startsWith('www.')) {
    return hostname;
  }
  const parts = hostname.split('.');
  return ['www', ...parts.slice(parts.length > 2 ? 1 : 0)].join('.');
}

/**
 * Builds a redirect URI using the canonical www. host.
 *   sleepiodev.com        → www.sleepiodev.com
 *   login.sleepiodev.com  → www.sleepiodev.com
 *   www.sleepiodev.com    → www.sleepiodev.com (unchanged)
 *   localhost             → localhost (unchanged — local dev safe)
 */
export function buildCanonicalRedirectUri() {
  const { protocol, hostname, pathname } = window.location;
  return `${protocol}//${_getCanonicalHost(hostname)}${pathname}`;
}

/**
 * If the current hostname is not www., redirects to the www. equivalent and returns true.
 * Returns false if no redirect was needed (caller can continue).
 */
export function redirectToCanonicalHostIfNeeded() {
  const { hostname, protocol, pathname, search } = window.location;
  const canonical = _getCanonicalHost(hostname);
  if (canonical === hostname) {
    return false;
  }
  window.location.replace(`${protocol}//${canonical}${pathname}${search}`);
  return true;
}
